<template>
  <div class="create_wrapper fadeIn">
    <!-- Start Breadcrumb -->
    <Breadcrumb :items="items" />
    <!-- End Breadcrumb -->

    <div class="custom_card">
      <div class="card-header">
        <h4 class="card-title">{{ $t("addNew") }}</h4>
      </div>
      <!-- ==== Start Form ==== -->
      <form @submit.prevent="validateCreateForm">
        <div class="container">
          <div class="row justify-content-between product">
            <div class="col-7 mx-auto">
              <div class="upload_input_wrapper">
                <template v-if="data.image">
                  <uplode-image
                    :data_src="data.image"
                    @inputChanged="uplodeImg"
                    placeHolder="الصورة"
                  ></uplode-image>
                </template>
                <template v-else>
                  <uplode-image
                    @inputChanged="uplodeImg"
                    placeHolder="الصورة"
                  ></uplode-image>
                </template>
              </div>
            </div>
            <!-- Project Name Input -->
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  @keypress="isArabic"
                  v-model.trim="data.title_ar"
                />
                <label for="name_input" class="form-label">
                  العنوان(عربي)</label
                >
              </div>
            </div>
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="text"
                  class="form-control"
                  @keypress="isEnglish"
                  v-model.trim="data.title_en"
                />
                <label for="name_input" class="form-label">
                  العنوان(انجليزي )</label
                >
              </div>
            </div>

            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <label for="textarea_1" class="form-label"> الوصف (عربي)</label>
                <textarea
                  class="form-control"
                  rows="4"
                  @keypress="isArabic"
                  v-model="data.description_ar"
                ></textarea>
              </div>
            </div>
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <label for="textarea_1" class="form-label">
                  الوصف (انجليزي)</label
                >
                <textarea
                  class="form-control"
                  rows="4"
                  @keypress="isEnglish"
                  v-model="data.description_en"
                ></textarea>
              </div>
            </div>
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  @keypress="isArabic"
                  v-model.trim="data.canonical_tags_ar"
                />
                <label for="name_input" class="form-label">
                  Canonical Tag(عربي)</label
                >
              </div>
            </div>
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="text"
                  class="form-control"
                  @keypress="isEnglish"
                  v-model.trim="data.canonical_tags_en"
                />
                <label for="name_input" class="form-label">
                  Canonical Tag(انجليزي )</label
                >
              </div>
            </div>
            <div class="col-lg-10">
              <div
                v-for="(item, index) in data.keywords"
                :key="index"
                class="row"
              >
                <div class="col-6 py-0">
                  <div class="input_wrapper top_label">
                    <input
                      type="text"
                      class="form-control"
                      @keypress="isArabic"
                      v-model.trim="item.keyword_ar"
                    />
                    <label for="name_input" class="form-label">
                      keywords (عربي )</label
                    >
                  </div>
                </div>
                <div class="col-6 py-0">
                  <div class="input_wrapper top_label">
                    <input
                      type="text"
                      class="form-control"
                      @keypress="isEnglish"
                      v-model.trim="item.keyword_en"
                    />
                    <label for="name_input" class="form-label">
                      keywords (انجليزي )</label
                    >
                  </div>
                </div>
              </div>
            </div>
            <!-- Actions -->
            <div class="col-lg-2 row">
              <div class="col-6 py-0" v-if="data.keywords.length > 0">
                <span class="append" @click="appendKeyword()">
                  <i class="fas fa-plus-circle"></i>
                </span>
              </div>
              <div class="col-lg-6 py-0" v-show="data.keywords.length > 1">
                <span class="append" @click="deleteKeyword()">
                  <i class="fas fa-minus-circle"></i>
                </span>
              </div>
            </div>
            <div class="col-6 py-0 mx-auto">
              <div class="input_wrapper top_label">
                <input
                  type="text"
                  class="form-control"
                  @keypress="isArabic"
                  v-model="data.type_ar"
                />
                <label for="name_input" class="form-label"> type (عربي) </label>
              </div>
            </div>
            <div class="col-6 py-0 mx-auto">
              <div class="input_wrapper top_label">
                <input
                  type="text"
                  class="form-control"
                  @keypress="isEnglish"
                  v-model="data.type_en"
                />
                <label for="name_input" class="form-label">
                  type (انجليزي)
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="buttons_wrapper">
          <button class="base-btn">
            {{ $t("forms.submit") }}
            <span class="btn_loader" v-if="btnIsLoading"></span>
          </button>
        </div>
      </form>
      <!-- ==== End Form ==== -->
    </div>
  </div>
</template>

<script>
export default {
  name: "Meta",
  data() {
    return {
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.intro.title"),
          disabled: false,
          href: "/home_page/intro",
        },
      ],

      // ========== Loading
      btnIsLoading: false,
      data: {
        canonical_tags_ar: null,
        canonical_tags_en: null,
        title_ar: null,
        title_en: null,
        description_ar: null,
        description_en: null,
        image: null,
        image_ar: null,
        type_en: null,
        type_ar: null,
        keywords: [
          {
            keyword_ar: null,
            keyword_en: null,
          },
        ],
      },
    };
  },

  methods: {
    uplodeImg(img) {
      this.data.image = img;
    },
    uplodeImgAr(img) {
      this.data.image_ar = img;
    },
    appendKeyword() {
      this.data.keywords.push({
        keyword_ar: null,
        keyword_en: null,
      });
    },
    deleteKeyword() {
      this.data.keywords.splice(-1);
    },
    // Validate Data
    validateCreateForm() {
      this.btnIsLoading = true;
      // if (!this.data.title_ar) {
      //     this.$iziToast.error({
      //     timeout: 2000,
      //     message: '   العنوان  مطلوب (عربي ) ',
      //     position: 'bottomRight',
      //     })
      //     this.btnIsLoading = false
      //     return
      // }  else if (!this.data.title_en) {
      //     this.$iziToast.error({
      //         timeout: 2000,
      //         message: '  العنوان   مطلوب (أنجليزي ) ',
      //         position: 'bottomRight',
      //     })
      //     this.btnIsLoading = false
      //     return
      // } else if (!this.data.description_ar) {
      //     this.$iziToast.error({
      //     timeout: 2000,
      //     message: '  الوصف   مطلوب (عربي ) ',
      //     position: 'bottomRight',
      //     })
      //     this.btnIsLoading = false
      //     return
      // }  else if (!this.data.description_en) {
      //     this.$iziToast.error({
      //         timeout: 2000,
      //         message: '   الوصف  مطلوب (أنجليزي ) ',
      //         position: 'bottomRight',
      //     })
      //     this.btnIsLoading = false
      //     return
      // }  else if (!this.data.canonical_tags_ar) {
      //     this.$iziToast.error({
      //     timeout: 2000,
      //     message: '  Canonical Tag   مطلوب (عربي ) ',
      //     position: 'bottomRight',
      //     })
      //     this.btnIsLoading = false
      //     return
      // }  else if (!this.data.canonical_tags_en) {
      //     this.$iziToast.error({
      //         timeout: 2000,
      //         message: '   Canonical Tag  مطلوب (أنجليزي ) ',
      //         position: 'bottomRight',
      //     })
      //     this.btnIsLoading = false
      //     return
      // }   else{
      //     return;
      //     }
      this.submitData();
    },

    // Submit Data
    submitData() {
      const submit_data = new FormData();

      submit_data.append("ar[title]", this.data.title_ar);
      submit_data.append("en[title]", this.data.title_en);
      submit_data.append("en[type]", this.data.type_en);
      submit_data.append("ar[type]", this.data.type_ar);

      if (this.data.image.img_file) {
        submit_data.append("image", this.data.image.img_file);
      }
      this.data.keywords.map((item, index) => {
        submit_data.append(`keywords[${index}][ar][keyword]`, item.keyword_ar);
        submit_data.append(`keywords[${index}][en][keyword]`, item.keyword_en);
      });
      submit_data.append("ar[description]", this.data.description_ar);
      submit_data.append("en[description]", this.data.description_en);
      submit_data.append("ar[canonical_tags]", this.data.canonical_tags_ar);
      submit_data.append("en[canonical_tags]", this.data.canonical_tags_en);
      this.axios({
        method: "POST",
        url: `home/meta`,
        data: submit_data,
      })
        .then(() => {
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("editSuccess"),
            position: "bottomRight",
          });
          this.$router.push({ path: "/home_page/intro" });
          this.btnIsLoading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
        });
    },
    // get Technologies
    getData() {
      this.loading = true;
      this.axios({
        method: "GET",
        url: `home/meta`,
      })
        .then((res) => {
          if (res.data.data) {
            this.data = res.data.data;
            if (!this.data.keywords.length) {
              this.appendKeyword();
            }
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },

  mounted() {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
.product {
  .chooseImage {
    width: auto !important;
  }
}
.border_main_color {
  border: 1px solid var(--mainColor-2_2);
  padding-block: 30px;
  border-radius: 15px;
  margin-block: 15px;
  h3 {
    margin-block-end: 10px;
  }
}
.productDetails {
  border: 1px solid #339989;
  border-radius: 15px;
  padding-block: 20px;

  &.disabled {
    cursor: not-allowed;

    h3 {
      color: gray;
      font-size: 25px;
    }

    h4 {
      font-size: 21px;
      color: gray;
    }

    & > * {
      pointer-events: none;
    }
  }
}
</style>
